import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import EditBlogDetails from './EditBlogDetails';

// Redux Action
import { getBlogDetails } from '../../../actions/getBlogDetails';

const title = 'Edit Page Details';

export default {

    path: '/siteadmin/edit/page/:blogId',

    async action({ store, params, query }) {

        // From Redux Store
        let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

        if (!isAdminAuthenticated) {
            return { redirect: '/siteadmin/login' };
        }

        const blogId = Number(params.blogId);

        if ("mode" in query) {
          if (query.mode === "new") {
            mode = query.mode;
          }
        }

        await store.dispatch(getBlogDetails(blogId));

        return {
            title,
            component: <AdminLayout><EditBlogDetails title={title} blogId={Number(blogId)} /></AdminLayout>,
        };
    },

};



// WEBPACK FOOTER //
// src/routes/siteadmin/editBlogDetails/index.js